// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__hU9ys","inner":"style_inner__2j-Zp","bottom":"style_bottom__1z1UJ","copyright":"style_copyright__3Qsca"};